import SimplePage from "@/components/layout/SimplePage";
import { useContent } from "@/hooks/useContent";

export default function Bulletin() {
  const { body: adminBody, loading } = useContent("bulletin.body", "");
  const hasAdminContent = !loading && !!(adminBody && adminBody.trim() && adminBody !== "<p></p>");

  return (
    <SimplePage
      title="Temple Bulletin & Weekly Newsletter"
      eyebrow="Newsletter & Bulletin"
      subtitle="Two ways TIOB stays in touch - the free weekly TIoB Weekly newsletter for everyone, and the members-only bi-monthly Bulletin."
      path="/bulletin"
      ctaLabel="Subscribe to the newsletter"
    >
      {hasAdminContent ? (
        <div dangerouslySetInnerHTML={{ __html: adminBody }} />
      ) : (
        <>
          <h2>TIoB Weekly &mdash; free, weekly, open to everyone</h2>
          <p>
            Our free weekly newsletter goes out to members and non-members alike
            every week. It highlights the upcoming Shabbat service, Torah portion,
            this week&rsquo;s scheduled events, notes from the rabbi, and any
            last-minute community announcements. Subscribe with the form at the
            bottom of any page on this site &mdash; friendly, occasional emails,
            never spam.
          </p>

          <h2>TIOB Bulletin &mdash; bi-monthly, members only</h2>
          <p>
            The <em>TIOB Bulletin</em> is our in-depth members-only publication,
            delivered every two months. It includes lifecycle announcements
            (b&rsquo;nei mitzvah, weddings, baby namings), yahrzeits being observed,
            board updates, donations received, and full articles from the rabbi and
            president. Members receive it by email as part of their membership.
          </p>

          <h2>What&rsquo;s inside each publication</h2>
          <ul>
            <li>This week&rsquo;s Shabbat service &mdash; time, Torah portion, special notes</li>
            <li>Upcoming events and RSVP deadlines</li>
            <li>Yahrzeits being observed this week (Bulletin)</li>
            <li>Religious-school news and family updates</li>
            <li>Social-action opportunities and volunteer calls</li>
            <li>Donations and gifts received with gratitude (Bulletin)</li>
            <li>Rabbi&rsquo;s note or d&rsquo;var Torah snippet</li>
          </ul>

          <h2>Submit an Announcement</h2>
          <p>
            Have a simcha to share, an event to publicize, or a yahrzeit to add?
            Please email{" "}
            <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a>{" "}
            at least two weeks in advance of the publication date you&rsquo;d like
            the announcement to appear.
          </p>
        </>
      )}
    </SimplePage>
  );
}
